import { Image } from '@mantine/core';
import { Link } from 'react-router-dom';
import type { Category } from 'TYPES/api.body';
import { normalizeCategoryLogoUrl, resolveLandingCategories } from 'utils/landingCategories';

interface Props {
  categories: Category[];
}

const BlobFlex: React.FC<Props> = ({ categories }) => {
  const landingCategories = resolveLandingCategories(categories);

  return (
    <div className="flex justify-center gap-14 padding-section py-24">
      {landingCategories.map(category => {
        const apiCategory = categories.find(item => item.id === category.id);
        const apiLogo = normalizeCategoryLogoUrl(apiCategory?.logo);
        const imageSrc = apiLogo ?? category.image;

        return (
          <div className="flex flex-col items-center group" key={category.slug}>
            <Link
              className="flex flex-col items-center"
              to={`/categories/${category.slug}?category=${category.id}`}>
              <div className="mb-2 overflow-hidden">
                <Image
                  src={imageSrc}
                  alt={category.name}
                  className="transition-transform duration-300 ease-in-out group-hover:scale-110 max-w-[200px] w-auto h-auto"
                  fallbackSrc={category.fallbackImage}
                  onError={event => {
                    const target = event.currentTarget;
                    if (target.src !== category.fallbackImage) {
                      target.src = category.fallbackImage;
                    }
                  }}
                />
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default BlobFlex;
